import { logError } from './ApiHelper';

export type TimerCallback = (elapsed: number) => void;

let startTime: number | null = null;
let timerId: NodeJS.Timeout | null = null;
let intervalMs = 1000;
const callbacks: Set<TimerCallback> = new Set();

const getElapsed = (): number => {
  return startTime ? Date.now() - startTime : 0;
};

export const globalTimer = {
  start: (interval = 1000): void => {
    if (timerId) {
      return;
    }

    startTime = Date.now();
    intervalMs = interval;

    timerId = setInterval(() => {
      const elapsed = getElapsed();
      callbacks.forEach(callback => {
        try {
          callback(elapsed);
        } catch (error) {
          logError(error, 'Error in globalTimer callback');
        }
      });
    }, intervalMs);
  },

  stop: (): void => {
    if (timerId) {
      clearInterval(timerId);
      timerId = null;
    }
  },

  reset: (): void => {
    globalTimer.stop();
    startTime = null;
    callbacks.clear();
  },

  getElapsed,

  getElapsedSeconds: (): number => {
    return Math.floor(getElapsed() / 1000);
  },

  getFormattedTime: (): string => {
    const seconds = globalTimer.getElapsedSeconds();
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return [hours, minutes, secs].map(val => String(val).padStart(2, '0')).join(':');
  },

  subscribe: (callback: TimerCallback): (() => void) => {
    if (!callback) return () => {};

    callbacks.add(callback);

    return () => {
      callbacks.delete(callback);
    };
  },

  isRunning: (): boolean => {
    return timerId !== null;
  },

  getInterval: (): number => {
    return intervalMs;
  },

  getSubscriberCount: (): number => {
    return callbacks.size;
  }
};
